import axios from 'axios'
import qs from 'qs'
export const commonParams = {}
const instance = axios.create({
  baseURL: 'https://api.pos.com.ve/',
  withCredentials: false,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
  }
})
// 添加请求拦截器
instance.interceptors.request.use(config => {
  let token = localStorage.getItem('token');
  if(token){
    config.headers.token = token;
  }
  if (config.url === 'Admin/upload') {
    config.headers['Content-Type'] = 'multipart/form-data'
  } else {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  return config
}, error => {
// 对请求错误做些什么
  return Promise.reject(error)
})

/**
 * 拦截响应response，并做一些错误处理
 */
instance.interceptors.response.use((response) => {
  const data = response.data
  //console.info('response', data)
  if (data) {
    switch (data.status) {
      case -1:
        localStorage.setItem('token', '');
        //console.log(this.$router)
        break
      case -8:
        // store.commit('setToken', '')
        break
        // 系统维护中
      case -9:
        // store.commit('setToken', '')
        break
      case 1:
        if(data.token){
          localStorage.setItem('token', data.token);
        }
        break
      case 2:
        if(data.token){
          localStorage.setItem('token', data.token);
        }
        break
      case 443:
        break
      default:
    }
    return response
  } else {
    const err = new Error('未知错误，请重试')
    err.data = data
    err.response = response
    console.log('err:' + err)
    throw err
  }
}, function (err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求参数错误'
        break
      default:
    }
  }
  return Promise.reject(err)
})

export default axios

/**
 * get请求
 * @param urlLink
 * @param param
 * @returns {Promise<AxiosResponse>}
 */
export function get (urlLink, param) {
  const url = urlLink
  const data = Object.assign({}, commonParams, param)
  return instance.get(url, {
    params: data,
    timeout: 5000
  })
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch(function (error) {
      //store.commit('setLoading', false)
      return Promise.resolve(error.data)
    })
}

/**
 * post请求
 * @param urlLink
 * @param param
 * @returns {Promise<AxiosResponse>}
 */
export function post (urlLink, param) {
  let _this = this
  this.$store.commit('setLoading', true)
  const data = Object.assign({}, commonParams, param)
  return instance.post(urlLink, qs.stringify(data))
    .then((res) => {
      this.$store.commit('setLoading', false)
      return Promise.resolve(res.data)
    })
    .catch(function (error) {
      _this.$store.commit('setLoading', false);
      //这里可以设置超时错误
      console.log(error.message)
      return Promise.resolve(error)
    })
}

/**
 * upload请求
 * @param urlLink
 * @param param
 * @returns {Promise<AxiosResponse>}
 */
export function upload (urlLink, param) {
  // console.log(param)
  //store.commit('setLoading', true)
  // const data = Object.assign({}, commonParams, param)
  return instance.post(urlLink, param)
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch(function (error) {
      //store.commit('setLoading', false)
      return Promise.resolve(error)
    })
}



// WEBPACK FOOTER //
// ./src/plugins/http_utils.js